import { emptyObject } from '@constants/empty';

export const getIsFetching = ({ quizzes }) => quizzes.isFetching;

export const getTestSeries = ({ paginator }) =>
  paginator.testSeries || emptyObject;

export const getGtpTestSeriesData = ({ quizzes }) => quizzes?.gtpTestSeries;
